export const SOCIAL_EMBED_WIDTH = 500;
export const TWITTER_SDK = "https://platform.twitter.com/widgets.js";
export const FLOURISH_REMOVE_CREDIT_TEXT_ID = 338859;
